// frontend/src/features/bapb/sections/IncomeActualsAdvancedSection.jsx
import React from "react";
import IncomeAdvanced from "./IncomeAdvanced";

export default function IncomeActualsAdvancedSection(props) {
  // Advanced Actuals saves under data.income_actuals_advanced
  return <IncomeAdvanced {...props} dataKey="income_actuals_advanced" />;
}
